import * as React from 'react';
export default function loadVector(name) {
  let vector;
  if (!name) {
    return vector;
  }
  try {
    const required = require(`../vectors/${name}`);
    vector = required.default || required;
  } catch (e) {}
  return vector;
}